var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project"},[_c('project-about'),_c('project-location'),_c('project-style'),_c('project-lobby'),_c('project-service'),_c('project-places'),_c('project-coworking'),_c('project-safety'),_c('scrollButton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }